import axios from "axios";
import BaseService from "../config/baseService";
import { API_GET_ELM_CAR_DETAIL } from "../config/webService";

class ElmService extends BaseService {
  async getCarDetail(istimaraSequenceNumber) {
    const result = await axios.get(API_GET_ELM_CAR_DETAIL, { params: { istimaraSequenceNumber } });
    return result && result.data?.response;
  }
}

export default new ElmService();
